export default {
    namespaced: true,

    actions: {
        fetchOperationsFinalAccounts(vuexContext, { financialFileId, userId }) {
            return window.axios.get(`Statistic/finalAccounts/operations`, {
                params: { financialFileId, userId }
            }).then(response => {
                return response.data;
            });
        },
        fetchTradeFinalAccount(vuexContext, { financialFileId, userId }) {
            return window.axios.get(`statistic/finalAccounts/trade`, {
                params: { financialFileId, userId }
            }).then(response => {
                return response.data;
            });
        },
        fetchGainsAndLossesFinalAccount(vuexContext, { financialFileId, userId }) {
            return window.axios.get(`statistic/finalAccounts/gainsAndLosses`, {
                params: { financialFileId, userId }
            }).then(response => {
                return response.data;
            });
        },
        fetchBudgetFinalAccount(vuexContext, { financialFileId, userId }) {
            return window.axios.get(`statistic/accounting/finalAccounts/Budget`, {
                params: { financialFileId, userId }
            }).then(response => {
                return response.data;
            });
        },

        fetchAccountCustomStatement(vuexContext, { customStatementId, financialFileId, userId, showNonZeroAccountsOnly }) {
            return window.axios.get(`statistic/statements/custom/${customStatementId}`,{
                params: { financialFileId, userId, showNonZeroAccountsOnly }
            }).then(response => {
                return response.data;
            })
        },
    }
}